<template>
  <generic-modal :title="$t('administrative documents')" ref="generic_modal">
    <div class="field">
      <div class="control">
        <generic-uploader
          ref="generic_uploader"
          :idle_label="$t('drop photos here')"
          endpoint_url="/air_project/admin_doc"
          :extra_data="{ project_uuid: uuid }"
          @error="error_uploading"
          @success="success_uploading"
          :allow_multiple="true"
        />
      </div>
    </div>

    <div class="grid is-col-min-7">
      <div class="cell" v-for="(photo, midx) in meta.photos" :key="midx">
        <div class="card">
          <div class="card-image">
            <figure class="image is-128x128 m-auto py-3">
              <v-lazy-image :src="`${api_host}/drive/static/${photo.file}`" />
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <!-- <p class="subtitle is-7 has-text-centered">
                  {{ photo.file }}
                </p> -->
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div
              class="button is-secondary card-footer-item"
              @click="remove(photo)"
              :data-tooltip="$t('delete')"
            >
              <span class="icon">
                <i class="fa fa-trash"></i>
              </span>
              <!-- <span>{{ $t("delete") }}</span> -->
            </div>
            <!-- <div
              class="button is-secondary card-footer-item"
              @click="describe(photo)"
              :data-tooltip="$t('describe')"
            >
              <span class="icon">
                <i class="fa fa-edit"></i>
              </span>
            </div> -->
          </footer>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-secondary is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  api_host,
  error_message,
  get,
  del,
  post,
  error_alert,
  input_alert,
  generate_error_message_text,
  confirm_deletion_dialog,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "AdministrativeDocumentsModal",
  components: { GenericModal, GenericUploader, VLazyImage },
  data() {
    return {
      api_host: api_host,
      meta: {},
      error: "",
      uuid: "",
    };
  },
  computed: {},
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(project_uuid) {
      // console.log("show_modal", project_uuid);
      let v = this;
      v.set_initial_state();

      if (project_uuid) {
        v.uuid = project_uuid;
        v.init();
        v.$refs.generic_modal.show_modal();
      } else v.$refs.generic_modal.show_modal();
    },
    init() {
      let v = this;
      get("/air_project/admin_doc/all", { uuid: v.uuid })
        .then((rspnse) => {
          v.meta.photos = rspnse.photos;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      v.uuid = "";
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      // let v = this;
      // v.$refs.generic_uploader.clear();
      // v.init();
    },
    remove(photo) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete document?"),
        v,
        () => {
          del("/air_project/admin_doc", { uuid: photo.uuid })
            .then(() => {
              v.init();
            })
            .catch((error) => {
              v.error = generate_error_message_text(error);
            });
        }
      );
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style scoped>
/* .grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
} */
</style>
